module.exports = __webpack_public_path__ + "img/searchname.b8f6d909.jpg";